var TransmissionMethod;
(function (TransmissionMethod) {
    TransmissionMethod["Cable"] = "cable";
    TransmissionMethod["Antenna"] = "antenna";
    TransmissionMethod["Satellite"] = "satellite";
    TransmissionMethod["Radio"] = "radio";
})(TransmissionMethod || (TransmissionMethod = {}));
export default TransmissionMethod;
